$(document).ready(function() {
  $('a[href^="#"]').on('click', function(event) {
    event.preventDefault();

    var target = $(this.getAttribute('href'));

    if (target.length) {
      var headerHeight = $('sticky-header.header-wrapper').outerHeight();

      $('html, body').animate({
        scrollTop: target.offset().top - headerHeight
      }, 800);
    }
  });
});